(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["browse-by-categories"] && !window.DesignMode) return;
  try {
    
$(function () {
    slick_slider_category();
});
$(document).on("shopify:section:load", function () {
    slick_slider_category();
});

$(document).on("shopify:section:unload", function () {
  slick_slider_category();
});

$(document).on("shopify:section:select", function () {
  slick_slider_category();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider_category();
});

function slick_slider_category() {
  $(".browse-by-categories__items").not(".slick-initialized").slick({
    dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 4
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2
      }
    }
  ]
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get-the-look"] && !window.DesignMode) return;
  try {
    
$(function () {
    slick_slider_look();
});
$(document).on("shopify:section:load", function () {
    slick_slider_look();
});

$(document).on("shopify:section:unload", function () {
  slick_slider_look();
});

$(document).on("shopify:section:select", function () {
  slick_slider_look();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider_look();
});

function slick_slider_look() {
  $(".get-the-look__items").not(".slick-initialized").slick({
   dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-collections"] && !window.DesignMode) return;
  try {
    
$(function () {
    slick_slider1();
});
$(document).on("shopify:section:load", function () {
    slick_slider1();
});

$(document).on("shopify:section:unload", function () {
  slick_slider1();
});

$(document).on("shopify:section:select", function () {
  slick_slider1();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider1();
});

function slick_slider1() {
  $(".shop-by-collections__items").not(".slick-initialized").slick({
    infinite: true,
  slidesToShow: 3,
  slidesToScroll: 2, 
    arrows:true,
        autoplay:true, 
    responsive: [
    {
      breakpoint: 749,
      settings: {
         arrows:false,
         centerMode: false,
        slidesToShow: 1.1,
        slidesToScroll: 1,
        infinite: true,
        
      }
    }
    ]
    
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow_bkp_31-01-2024"]) return;
  try {
    
$(function () {
    slick_slider();
});
$(document).on("shopify:section:load", function () {
    slick_slider();
});

$(document).on("shopify:section:unload", function () {
  slick_slider();
});

$(document).on("shopify:section:select", function () {
  slick_slider();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider();
});

function slick_slider() {
  $(".slideshow__items").not(".slick-initialized").slick({
     fade: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: $('.slideshow' ).data('autoplay-speed'),
        appendDots: '.slideshow__nav-wrapper'
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending-now"] && !window.DesignMode) return;
  try {
    
$(function () {
    slick_slider_trending();
});
$(document).on("shopify:section:load", function () {
    slick_slider_trending();
});

$(document).on("shopify:section:unload", function () {
  slick_slider_trending();
});

$(document).on("shopify:section:select", function () {
  slick_slider_trending();
});

$(document).on("shopify:section:deselect", function () {
  slick_slider_trending();
});

function slick_slider_trending() {
  $(".trending-now__items").not(".slick-initialized").slick({
   dots: false,
    arrows: true,
    autoplay: false,
    slidesToShow: 4,
        slidesToScroll: 3,
        infinite: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 2
      }
    }
  ]
  });
}


  } catch(e) { console.error(e); }
})();
})();
